import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { RecentInboxQuery, RecentInboxQueryVariables } from '@/shared/api';
import RECENT_INBOX_QUERY from '../queries/recentInbox';

/**
 * Loads a recently received inbox report. Runs the recent inbox query for the id and throws the first GraphQL error only when no report came back.
 *
 * @param id - Identifier of the report to load.
 * @returns A promise resolving to the recent inbox report.
 */
const fetchRecentInbox = async (id: any) => {
  const client = createClient();
  const recentInboxResult = await client.query<RecentInboxQuery, RecentInboxQueryVariables>({
    query: RECENT_INBOX_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = recentInboxResult;
  const { report } = data;
  if (_.isNil(report) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return report;
};

export default fetchRecentInbox;
